import {
  EMAIL_DOMAIN_DELETE_FLOW_NAME,
  EMAIL_DOMAIN_INFO_FLOW_NAME,
  EMAIL_DOMAIN_INSERT_FLOW_NAME,
} from '@/features/campaigns/EmailCampaign/constants';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetConnectorFlowsQuery, useGetConnectorInstancesQuery } from '@/services/endpoints/workspace-connectors';

export const useEmailSendingDomainConnector = () => {
  const workspace = useWorkspace();

  const {
    data: connectorFlows,
    isLoading: isFlowsLoading,
    isError: isFlowsError,
  } = useGetConnectorFlowsQuery({ workspaceId: workspace.id, queryParams: { showUserJourney: true } }, { skip: !workspace.id });

  const {
    data: connectorInstances,
    isLoading: isInstancesLoading,
    isError: isInstancesError,
  } = useGetConnectorInstancesQuery({ workspaceId: workspace.id }, { skip: !workspace.id });

  const domainInsertFlow = connectorFlows?.find((flow) => flow.name === EMAIL_DOMAIN_INSERT_FLOW_NAME);
  const domainInfoFlow = connectorFlows?.find((flow) => flow.name === EMAIL_DOMAIN_INFO_FLOW_NAME);
  const domainDeleteFlow = connectorFlows?.find((flow) => flow.name === EMAIL_DOMAIN_DELETE_FLOW_NAME);

  const connectorId = domainInsertFlow?.connectorId ?? domainInfoFlow?.connectorId ?? domainDeleteFlow?.connectorId;
  const connectorInstanceId = connectorInstances?.find((instance) => instance.connectorId === connectorId)?.id;

  const isLoading = isFlowsLoading || isInstancesLoading;
  const isError = isFlowsError || isInstancesError;
  const isInsertReady = !!domainInsertFlow?.id && !!connectorInstanceId;
  const isInfoReady = !!domainInfoFlow?.id && !!connectorInstanceId;
  const isDeleteReady = !!domainDeleteFlow?.id && !!connectorInstanceId;

  return {
    /** @deprecated Use insertFlowId */
    flowId: domainInsertFlow?.id,
    insertFlowId: domainInsertFlow?.id,
    infoFlowId: domainInfoFlow?.id,
    deleteFlowId: domainDeleteFlow?.id,
    connectorInstanceId,
    connectorId,
    isLoading,
    isError,
    isReady: isInsertReady,
    isInsertReady,
    isInfoReady,
    isDeleteReady,
    missingInsertFlow: !isLoading && !domainInsertFlow,
    missingInfoFlow: !isLoading && !domainInfoFlow,
    missingDeleteFlow: !isLoading && !domainDeleteFlow,
    missingFlow: !isLoading && !domainInsertFlow,
    missingInstance: !isLoading && !!domainInsertFlow && !connectorInstanceId,
  };
};
